import http from "../http-common";

export default class {
  getFAQs(urlPath: string) {
    let url = `/faq?path=${encodeURIComponent(urlPath)}`;

    return http.get(url);
  }
}